import { render, staticRenderFns } from "./loadingTest.vue?vue&type=template&id=55fe843d&scoped=true&lang=html&"
var script = {}
import style0 from "./loadingTest.vue?vue&type=style&index=0&id=55fe843d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55fe843d",
  null
  
)

export default component.exports